import { HABITAT_INTACTNESS_KEY, HabitatIntactnessAndThreats, ThreatType } from '@/api/rest/resources/types/fact';
import { Logger } from '@/lib/logs/logger';
import { resolveThemeColor } from '@/utils/resolveThemeColor';

export const getColorForThreat = (threat: HabitatIntactnessAndThreats): string => {
  switch (threat) {
    case ThreatType.no_threat_area:
      return resolveThemeColor('threat-no_threat_area-fill');
    case ThreatType.cropland:
      return resolveThemeColor('threat-cropland-fill');
    case ThreatType.deforestation:
      return resolveThemeColor('threat-deforestation-fill');
    case ThreatType.builtup:
      return resolveThemeColor('threat-builtup-fill');
    case ThreatType.roads:
      return resolveThemeColor('threat-roads-fill');
    case HABITAT_INTACTNESS_KEY:
      return resolveThemeColor('habitat-intactness-fill');
    default:
      Logger.error(`No color defined for threat "${threat}"`);
      return '#000000';
  }
};

export const getMapBinaryColorForThreat = (
  threat: HabitatIntactnessAndThreats,
): {
  presence: string;
  absence: string;
} => {
  switch (threat) {
    case ThreatType.no_threat_area:
      return {
        presence: resolveThemeColor('threat-no_threat_area-binary-presence'),
        absence: resolveThemeColor('threat-no_threat_area-binary-absence'),
      };
    case ThreatType.cropland:
      return {
        presence: resolveThemeColor('threat-cropland-binary-presence'),
        absence: resolveThemeColor('threat-cropland-binary-absence'),
      };
    case ThreatType.deforestation:
      return {
        presence: resolveThemeColor('threat-deforestation-binary-presence'),
        absence: resolveThemeColor('threat-deforestation-binary-absence'),
      };
    case ThreatType.builtup:
      return {
        presence: resolveThemeColor('threat-builtup-binary-presence'),
        absence: resolveThemeColor('threat-builtup-binary-absence'),
      };
    case ThreatType.roads:
      return {
        presence: resolveThemeColor('threat-roads-binary-presence'),
        absence: resolveThemeColor('threat-roads-binary-absence'),
      };
    case HABITAT_INTACTNESS_KEY:
      return {
        presence: resolveThemeColor('habitat-intactness-binary-presence'),
        absence: resolveThemeColor('habitat-intactness-binary-absence'),
      };
    default:
      Logger.error(`No map binary colors defined for threat "${threat}"`);
      return {
        presence: '#000000',
        absence: '#000000',
      };
  }
};
